import { Link, useParams } from "react-router-dom";

export const Banner = ({ banner }) => {
    const { school } = useParams();

    if (banner.link === undefined || banner.link === null) return null;
    const image = (
        <>
            <img className="image pc _pc" src={banner.imagePc} alt="PC" />
            <img className="image mobile _m" src={banner.imageM} alt="모바일" />
        </>
    );
    switch (banner.linkType) {
        case 'book':
            return <Link to={`/${school}/book/${banner.link}`}>{image}</Link>;
        case 'notice':
            return <Link to={`/${school}/notice/${banner.link}`}>{image}</Link>;
        case 'direct':
        default:
            return <a href={banner.link} target="_blank" rel="noreferrer">{image}</a>;
    }
}